// extracted by mini-css-extract-plugin
module.exports = {"container":"Rating_container__24gET","lg":"Rating_lg__2jq5v","sm":"Rating_sm__2IdFv","md":"Rating_md__3m0PI"};